{
  "nl": {
    "wysiwyg": {
      "actions": {
        "alignCenter": "Centreren",
        "alignLeft": "Links uitlijnen",
        "alignRight": "Rechts uitlijnen",
        "blockType": "Alineatype",
        "blockquote": "Citaat",
        "bold": "Vet",
        "bulletList": "Ongeordende lijst",
        "code": "Code",
        "codeBlock": "Codeblok",
        "fontFamily": "Lettertype",
        "fontSize": "Lettergrootte",
        "h1": "Kop 1",
        "h2": "Kop 2",
        "h3": "Kop 3",
        "highlight": "Markeren",
        "horizontalRule": "Scheidingslijn",
        "iframe": "iFrame insluiten",
        "images": "Afbeeldingen invoegen",
        "italic": "Cursief",
        "katex": "LaTeX-formule",
        "katexBlock": "LaTeX-formuleblok",
        "link": "Link",
        "more": "Invoegopties",
        "orderedList": "Geordende lijst",
        "redo": "Herstellen",
        "specialCharacters": "Speciale tekens",
        "strikethrough": "Doorstreept",
        "table": "Tabel",
        "textColor": "Tekstkleur",
        "underline": "Onderstreept",
        "undo": "Ongedaan maken"
      },
      "blockTypes": {
        "five": "Kop 5",
        "four": "Kop 4",
        "one": "Kop 1",
        "paragraph": "Alinea",
        "six": "Kop 6",
        "three": "Kop 3",
        "two": "Kop 2"
      },
      "dialogs": {
        "deleteTable": {
          "text": "De tabel wordt verwijderd met alle inhoud erin.",
          "title": "Tabel verwijderen?"
        },
        "iframe": {
          "text": "Voer de URL in van de pagina die als iFrame in de tekst wordt ingesloten.",
          "title": "iFrame insluiten"
        },
        "link": {
          "text": "Voer de URL in waarnaar de gemarkeerde tekst moet linken.",
          "title": "Link invoegen"
        },
        "urlPrompt": {
          "label": "URL",
          "placeholder": "Voorbeeld: https://example.com"
        }
      },
      "specialCharactersModal": {
        "categories": {
          "Arrows": "Pijlen",
          "Basic Latin": "Basis-Latijn",
          "Currency Symbols": "Valutasymbolen",
          "Dingbats": "Dingbats",
          "Enclosed Alphanumerics": "Ingesloten alfanumerieke tekens",
          "General Punctuation": "Algemene interpunctie",
          "Geometric Shapes": "Geometrische vormen",
          "Greek and Coptic": "Grieks en Koptisch",
          "Latin Extended-A": "Latijn uitgebreid-A",
          "Latin Extended-B": "Latijn uitgebreid-B",
          "Latin-1 Supplement": "Latijn-1 aanvulling",
          "Mathematical Operators": "Wiskundige operatoren",
          "Miscellaneous Symbols": "Diverse symbolen",
          "Miscellaneous Technical": "Diverse technische tekens",
          "Superscripts and Subscripts": "Superscript en subscript"
        },
        "header": "Speciale tekens"
      }
    }
  }
}
